import { FC } from 'react';
import {
  BLOCKS,
  MARKS,
  INLINES,
} from '@contentful/rich-text-types';

import classes from 'src/styles/_commonClasses.module.scss';
import { CommonRichText } from 'components/Shared/SharedComponents';
import { RichTextParsersConfig } from 'types/objectTypes';

import styles from './DynamicModalWithStore.module.scss';

import { ChildProps } from '../config/declarations';

const parsersConfig: RichTextParsersConfig = {
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.text,
  },
  [INLINES.HYPERLINK]: {
    classNames: styles.link,
  },
  [MARKS.BOLD]: {
    classNames: classes.textBold,
  },
};

export const LegalTermsSection: FC<ChildProps> = ({
  block,
}) => {
  if (!block || !block.content) {
    return null;
  }

  return (
    <div className={styles.legal}>
      <CommonRichText content={block.content} parsersConfig={parsersConfig} />
    </div>
  );
};
